import LoadingIcon from "@/app/assets/icons/loading";
import { formatIndianCurrency, formatNumberWithCommas } from "@/app/utils/helper";
import React from "react";

interface BasketBreakupProps {
    BasketData: {
        companyName: string;
        ISIN: string;
        units: number;
        amount: number;
    }[];
}

export const BasketBreakup = ({ BasketData }: BasketBreakupProps) => {
    return (
        <div className="w-auto rounded-xl border border-gray-200 bg-white shadow-lg">
            <p className="p-s9 text-center text-md font-semibold">Basket Breakup</p>
            <div className="">
                <div className="overflow-hidden rounded-b-xl shadow-md">
                    <table className="w-full">
                        <thead className="min-w-full px-s9 py-s5">
                            <tr className="bg-neutralOpacityDark-30">
                                <th className="px-[1.4rem] py-3 text-left text-sm font-regular text-white">
                                    Company
                                </th>
                                <th className="px-[1.4rem] py-3 text-left text-sm font-regular text-white">
                                    Units
                                </th>
                                <th className="px-[1.4rem] py-3 text-left text-sm font-regular text-white">
                                    Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                            {BasketData?.length > 0 ? (
                                BasketData?.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td
                                            className="truncate whitespace-normal px-[1.4rem] py-4 text-sm text-gray-900"
                                            title={item?.companyName}
                                        >
                                            {item?.companyName}
                                        </td>
                                        <td className="px-[1.4rem] py-4 text-sm text-gray-900">
                                            {formatNumberWithCommas(item?.units ?? 0)}
                                        </td>
                                        <td className="px-[1.4rem] py-4 text-sm text-gray-900">
                                            {formatIndianCurrency(item?.amount ?? 0)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="px-[1.4rem] py-4 text-center">
                                        <div className="flex items-center justify-center">
                                            <LoadingIcon className="animate-spin" />
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
